export default __webpack_public_path__ + "static/rdv-9b843f634f010506680f2ba3cfbc4ae8.png";